import { useState, useEffect, forwardRef } from "react";
import axios from "axios";
import { Card } from "../../components/ui/card";
import { Loader2 } from "lucide-react";
import { GetStaffId } from "../../adapters/utils";
import { Chip } from "@mui/material";
import { CheckFat, PaperPlaneTilt } from "@phosphor-icons/react";
import { X } from "@phosphor-icons/react";
import { Check } from "@phosphor-icons/react";
import addicon from "../../assets/addicon.svg";
import { useViewAllinformationByid } from "../../adapters/Requests";
import { useParams } from "react-router-dom";
import { viewFileFromS3 } from "../../utils/funtions";
import ApplicantPhoto from "./ApplicantPhoto";
import { applicationStatuses } from "../../utils/constants";

function ViewCandidate() {
  // const [previewSrc, setPreviewSrc] = useState(addicon);

const params = useParams();
const application_id = applicationId || params.application_id;
const { data, isLoading, isError } = useViewAllinformationByid({
  application_id,
});

  const {
    REVIEW,
    INVALIDATED,
    RETURNED,
    VERIFIED,
    APPROVED,
    REJECTED,
    DECLINED,
    ACCEPTED,
  } = applicationStatuses;

  // useEffect(() => {
  //   (async function () {
  //     try {
  //       if (data?.Applicant?.passport_photo) {
  //         const signedUrl = await viewFileFromS3(
  //           data?.Applicant?.passport_photo
  //         );
  //         setPreviewSrc(signedUrl);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching file:", error);
  //     }
  //   })();
  // }, [data?.Applicant?.passport_photo]);

  return (
    <Card className="w-auto h-auto bg-white border-[#F4F4F4] border-1.5px ">
      {isLoading ? (
        <Loader2 className="w-16 h-16 stroke-accent animate-spin mx-auto my-8" />
      ) : data ? (
        <div className="mb-4 mt-9">
          <div className="flex flex-wrap justify-between items-center px-[1.5rem]">
            <ApplicantPhoto />
            {/* <div className="flex items-center mb-4">
              <div className="flex-shrink-0 p-1 bg-gray-200 rounded-lg w-24 h-24">
                {data.Applicant.passport_photo ? (
                  <img
                    src={previewSrc}
                    alt="Passport Photo"
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <UserIcon className="w-full h-full p-4 text-gray-400" />
                )}
              </div>
              <div className="ml-4">
                <h2 className="text-[#424242] text-xl font-semibold text-[24px]">
                  {data.Applicant.firstname + " " + data.Applicant.lastname}
                </h2>
                <p className="text-sm text-gray-500 text-[16px]">
                </p>
              </div>
            </div> */}
            <div className="flex flex-col items-end gap-4 mb-4">
              <div className="flex items-end relative left-4 mb-4">
                {data?.status === VERIFIED ? (
                  <Chip
                    color="success"
                    label={VERIFIED}
                    className="mr-10 w-44 h-14"
                  />
                ) : data?.status === INVALIDATED ? (
                  <Chip
                    color="error"
                    label={INVALIDATED}
                    className="mr-10 w-32 h-14"
                  />
                ) : data?.status === RETURNED ? (
                  <Chip label={RETURNED} className="mr-10 w-32 h-14" />
                ) : data?.status === APPROVED ? (
                  <Chip
                    color="success"
                    label={APPROVED}
                    className="mr-10 w-32 h-14"
                  />
                ) : data?.status === REJECTED ? (
                  <Chip
                    color="error"
                    label={REJECTED}
                    className="mr-10 w-32 h-14"
                  />
                ) : data?.status === DECLINED ? (
                  <Chip
                    color="error"
                    label={DECLINED}
                    className="mr-10 w-32 h-14"
                  />
                ) : data?.status === ACCEPTED ? (
                  <Chip
                    color="success"
                    label={ACCEPTED}
                    className="mr-10 w-32 h-14"
                  />
                ) : (
                  <>
                    <Chip label={REVIEW} className="mr-10 w-32 h-14" />
                  </>
                )}
              </div>
              <div className="flex gap-4">
                <div className="flex items-center space-x-4 text-gray-400 text-bold">
                  <PhoneIcon className="h-5 w-5 text-[#B0E7C9]" />
                  <span className="text-[#424242] text-sm text-[20px] font-[500]">
                    {data.Applicant.phone_number}
                  </span>
                </div>
                <div className="flex items-center space-x-4 text-gray-400 text-bold">
                  <MailIcon className="h-5 w-5 text-[#B0E7C9]" />
                  <span className="text-[#424242] text-sm text-[20px] font-[500]">
                    {data.Applicant.email}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>No data available</div>
      )}
    </Card>
  );
}

function MailIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect width="20" height="16" x="2" y="4" rx="2" />
      <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
    </svg>
  );
}

function PhoneIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.86 19.86 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.86 19.86 0 0 1 2 4.18 2 2 0 0 1 4 2h3a2 2 0 0 1 2 1.72c.13 1.3.36 2.56.7 3.78a2 2 0 0 1-.45 2.11L7 10.73a16 16 0 0 0 6 6l1.12-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
    </svg>
  );
}

function UserIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  );
}

export default ViewCandidate;
